(function() {
    /** @ngInject */
    function onKeyEnterDirective(){
        return{
            scope : {
                onKeyEnter : '&'
            },
            link: function(scope, element, attrs) {
                angular.element(element[0]).on("keydown", function(e){
                    if(e.which == 13 && !_.isUndefined(scope.onKeyEnter) && _.isFunction(scope.onKeyEnter))
                        scope.onKeyEnter.call();
                    scope.$apply();
                });

            }
        };
    }
    /** @ngInject */
    function momentMSDirective(Utils) {
        return function(date, format) {
            if(format == 'mediumDate'){
                if(language === 'sw')
                    format = 'ddd D MMMM, YYYY';
                else
                    format  =   'ddd, MMMM D, YYYY';
            }

            return (!_.isNumber(date) || date <= 0) ? '' : moment.tgz(date*1000).format(format);
        };
    }
    angular.module("Waiteraid").directive("momentMS", momentMSDirective);
    angular.module("Waiteraid").directive("onKeyEnter", onKeyEnterDirective);
})();
